import { dateFromObjectId } from "@xola/ui-kit";
import dayjs, { Dayjs } from "dayjs";
import { getAuditData } from "@/models/Audit";

export interface AuditGroupingConfig {
    thresholdSeconds: number;
    isGroupable: (change: any) => boolean;
    merge: (base: any, next: any) => any;
}

export const getAuditChangeTime = (change: any): Dayjs => {
    return change.createdAt ? dayjs(change.createdAt) : dayjs(dateFromObjectId(change.id));
};

export const getAuditChangeUserId = (change: any): string | null => {
    const audit = change.data ? getAuditData(change) : null;
    return audit?.createdBy?.id ?? null;
};

export const applyAuditGrouping = (sortedList: any[], config: AuditGroupingConfig): any[] => {
    const result: any[] = [];
    let baseAudit: any = null;
    let lastTime: Dayjs | null = null;
    let lastUserId: string | null = null;

    for (const change of sortedList) {
        const shouldGroup = config.isGroupable(change);

        if (!shouldGroup) {
            if (baseAudit) {
                result.push(baseAudit);
                baseAudit = null;
                lastTime = null;
                lastUserId = null;
            }

            result.push(change);
            continue;
        }

        const currentTime = getAuditChangeTime(change);
        const currentUserId = getAuditChangeUserId(change);

        if (baseAudit && lastTime) {
            const diffInSeconds = Math.abs(lastTime.diff(currentTime, "second"));
            const isSameUser = lastUserId === currentUserId;
            const hasUser = !!currentUserId;

            if (diffInSeconds <= config.thresholdSeconds && isSameUser && hasUser) {
                baseAudit = config.merge(baseAudit, change);
                lastTime = currentTime;
                continue;
            }
        }

        if (baseAudit) {
            result.push(baseAudit);
        }

        baseAudit = change;
        lastTime = currentTime;
        lastUserId = currentUserId;
    }

    if (baseAudit) {
        result.push(baseAudit);
    }

    return result;
};
